import React, {ReactNode} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import MainHeaderBlockData from '../../../Models/Content/HeaderMainBlockData';
import MainHeader from './MainHeader';

export default class HeaderMainBlock extends EpiComponent<MainHeaderBlockData> {
  public render(): ReactNode | null {
    return <MainHeader iContent={this.props.data} context={this.getContext()} />;
  }
}
